export const isEmptyRichText = (value: string) => ['<p><br></p>', '<p></p>', ''].includes(value);
